import { useEffect, useMemo } from "react";
import Dropdown from "../../../../components/misc/Dropdown";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getWorkingRoutesNodes } from "../../../../redux/api/expedition.api";

function NodesBarcode({
  selectedValue,
  setSelectedValue,
}: {
  selectedValue: any;
  setSelectedValue: any;
}) {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      workingRoutesNodes: {
        data: { data: workingNodes },
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(
      getWorkingRoutesNodes({
        page: 1,
        perPage: 1000,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (workingNodes.length) {
      setSelectedValue({
        id: workingNodes[0]?.id_nod,
        label: workingNodes[0]?.nodNume,
      });
    }
  }, [setSelectedValue, workingNodes]);

  const workingNodesDropdownValues = useMemo(
    () =>
      workingNodes?.map((item) => ({
        label: item.nodNume,
        id: item.id_nod,
      })),
    [workingNodes],
  );

  const handleSelectValue = (value: any) => {
    setSelectedValue(value);
  };

  return (
    <Dropdown
      className="my-4 mt-10"
      title="Noduri"
      data={workingNodesDropdownValues}
      singleValue={{
        id: selectedValue?.id || "",
        label: selectedValue?.label || "",
      }}
      setSingleValue={handleSelectValue}
    />
  );
}

export default NodesBarcode;
